import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useEffect } from 'react';
import Utils from '../../utils';
import FilePreviewFrame from './FilePreviewFrame';

var ImageFilePreview = function ImageFilePreview(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      src = _React$useState2[0],
      setSrc = _React$useState2[1];

  useEffect(function () {
    Utils.apiClients.files.getResourceToken(workspace, path).then(function (resourceToken) {
      var htmlSrc = "".concat(Utils.getHost(), "/backend/preview?resourceToken=") + encodeURIComponent(resourceToken) + '&workspace=' + encodeURIComponent(workspace) + '&path=' + encodeURIComponent(path) + '&type=reader&' + new Date().getTime();
      setSrc(htmlSrc);
    });
  }, [workspace, path]);
  if (!src) return null;
  return React.createElement("div", {
    style: {
      paddingTop: 20,
      paddingBottom: 15,
      textAlign: 'center'
    }
  }, React.createElement("img", {
    src: src
  }));
};

export default ImageFilePreview;